import { LoadableAfterPaint } from '@confluence/loadable';

export const PageTreeMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageTreeMacro" */ '../src/PageTreeMacroRenderer.tsx'
			)
		).PageTreeMacroRenderer,
});
